export default "__VITE_ASSET__loCBh4q9__ 300w";